import { render, staticRenderFns } from "./EditLetter.vue?vue&type=template&id=4a209ab6&scoped=true&"
import script from "./EditLetter.vue?vue&type=script&lang=js&"
export * from "./EditLetter.vue?vue&type=script&lang=js&"
import style0 from "./EditLetter.vue?vue&type=style&index=0&id=4a209ab6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a209ab6",
  null
  
)

export default component.exports